'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
var $ = require("jquery");
var _upload_1 = require("./_upload");
var _hero_1 = require("./_hero");
// import BgBubble from './_bg_bubble';
var _about_1 = require("./_about");
var _youtube_1 = require("./_youtube");
var _carousel_1 = require("./_carousel");
var _navi_1 = require("./_navi");
var _recruit_1 = require("./_recruit");
var _entry_1 = require("./_entry");
var _staff_1 = require("./_staff");
var _message_1 = require("./_message");
var _work_1 = require("./_work");
var _blog_accesslog_1 = require("./_blog_accesslog");
var _pulldown_1 = require("./_pulldown");
$(function () {
    new _upload_1.default.MyUpload();
    new _hero_1.default.MyHero();
    // new BgBubble.MyBgBubble();
    new _about_1.default.MyAbout();
    new _youtube_1.default.MyYoutube();
    new _carousel_1.default.MyCarousel();
    new _navi_1.default.MyNavi();
    new _recruit_1.default.MyRecruit();
    new _entry_1.default.MyEntry();
    new _staff_1.default.MyStaff();
    new _message_1.default.MyMessage();
    new _work_1.default.MyWork();
    new _blog_accesslog_1.default.MyBlogAccesslog();
    new _pulldown_1.default.MyPullDown();
    $('#trigBlogTagsTitle').on('click', function () {
        var open = $(this).attr('data-open');
        if (open == "1") {
            $('#bulletBlogTagsTitle').slideUp('fast');
            $(this).attr('data-open', 0);
            $('#trigBlogTagsTitleIcon').html('<i class="fas fa-chevron-right"></i>');
        }
        else {
            $('#bulletBlogTagsTitle').slideDown();
            $(this).attr('data-open', 1);
            $('#trigBlogTagsTitleIcon').html('<i class="fas fa-chevron-down"></i>');
        }
    });
});
